import { _ } from "../../vendor";

import InboomaBaseAsyncCollection from "./InboomaBaseAsyncCollection";
import Wallet from "../models/Wallet";

export default InboomaBaseAsyncCollection.extend({
  collectionName: "wallets",
  model: Wallet,
  url: "/wallets",

  _pagination: {
    current_page: 0,
    sort: "id",
    sortDirection: "desc",
    has_next_page: false,
    has_prev_page: false,
    count: 0,
    limit: 50,
  },
});
